import LaunchIcon from '@src/components/icons/Launch'
import { useExchangeDataContext } from '@src/pages/Exchange/context/ExchangeDataContext'

interface ISwapModalFooterProps {
    transactionHash?: string
    isSwapCompleted?: boolean
    enableNewTxButton?: boolean
}

export default function SwapModalFooter({
    transactionHash = '',
    isSwapCompleted = false,
    enableNewTxButton = true,
}: ISwapModalFooterProps) {
    /**
     * * * * * * * * * * * * * * * * * * * * * NEW EXCHANGE DATA CONTEXT * * * * * * * * * * * * * * *
     */
    const { sellData, updateSellData, buyData, updateBuyData } = useExchangeDataContext()
    /**
     * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
     */

    const handleNewTransaction = () => {
        // Reset sell and buy data to initial state
        updateSellData({ ...sellData, value: BigInt(0) })
        updateBuyData({ ...buyData, value: BigInt(0) })
    }

    return (
        <div className='flex gap-3'>
            {!isSwapCompleted ? (
                <a
                    href={transactionHash}
                    target='_blank'
                    rel='noreferrer'
                    className='flex items-center gap-2 rounded-lg border border-[#313339] px-[18px] py-4 text-sm font-medium text-[#959699]'
                >
                    View on block explorer
                    <LaunchIcon />
                </a>
            ) : (
                <a
                    href={'/orders/'}
                    className='flex items-center gap-2 rounded-lg border border-[#313339] px-[18px] py-4 text-sm font-medium text-[#959699]'
                >
                    View on Orders page
                    <LaunchIcon />
                </a>
            )}
            {enableNewTxButton && (
                <a
                    href={'/'}
                    onClick={handleNewTransaction}
                    className='flex flex-grow items-center justify-center gap-2 rounded-lg border border-none bg-[#349FFD] p-4 text-sm font-medium'
                >
                    New Transaction
                </a>
            )}
        </div>
    )
}
